import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";
import { busca_media_disciplina_ciclo, pega_ranking_soma, pega_matriz_curricular } from "../../services/api";
import { ConverteSerie, ConverteSegmentoSig, ordem, } from "./modulo";
import { set } from "react-hook-form";

import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';

const Ranking_Alunos_Serie = (props) => {


    const [data2, setData2] = useState([]);
    const [avaliacao, setAvaliacao] = useState('AS4');
    const [serie, setSerie] = useState('1-1');
    const [matrizCurricular, setMatrizCurricular] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    let cod_unidade = props.un;

    const perfil = JSON.parse(localStorage.getItem("perfil"));

    // Lista de opções para os ComboBoxes
    const avaliacaoOptions = ['AS1', 'AS2', 'AS3', 'AS4'];
    const serieOptions = [
        { value: '1-1', label: '1º Fund I' },
        { value: '1-2', label: '2º Fund I' },
        { value: '1-3', label: '3º Fund I' },
        { value: '1-4', label: '4º Fund I' },
        { value: '1-5', label: '5º Fund I' },
        { value: '1-6', label: '6º Fund II' },
        { value: '1-7', label: '7º Fund II' },
        { value: '1-8', label: '8º Fund II' },
        { value: '1-9', label: '9º Fund II' },
        { value: '2-1', label: '1ª Médio' },
        { value: '2-2', label: '2ª Médio' },
        { value: '2-3', label: '3ª Médio' },
    ];

    const fetchData = async () => {
        try {
            const response = await pega_ranking_soma();
            console.log("RES=", response);
            setData2(response);
            const response2 = await pega_matriz_curricular();
            console.log("RES2=", response2);
            setMatrizCurricular(response2);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [serie]);

    let chartDatSerie = [];

    // let data2Filter = data2.filter(item => item.unidade === cod_unidade);
    //console.log('data2Filter', data2Filter)

    // Desempenho D é dado pela formula = ((sommatorio)/((número de disciplinas da serie do aluno)*25)*100
    // ou seja, se o aluno tem 3 disciplinas , por ciclo o máximo que pode fazer é 75 pontos, então se ele fez 50 pontos no ciclo 1, ele fez 66,66% do máximo que poderia fazer.
    // O somatório é feito por ciclo, então se ele fez 50 no ciclo 1, 60 no ciclo 2, 70 no ciclo 3 e 80 no ciclo 4, o somatório é 260, e o máximo que ele poderia fazer é 300, então ele fez 86,66% do máximo que poderia fazer.
    // desempenho percentual por ciclo = (somatório de notas por ciclo)/(número de disciplinas da serie do aluno)*25)*100
    // como a lista de somatorios tem alunos de séries diferentes, é preciso calcular o número de disciplinas da série do aluno. A série do aluno é no formato grau-serie (ex: 1-1, 1-2, 1-3, 1-4, 1-5, 1-6, 1-7, 1-8, 1-9, 2-1, 2-2, 2-3). dada uma turma, por exemplo 11611, o grau é o primeiro digito e a série é o terceiro digito, sendo assim essa turma é do 1º grau e da série 6, ou seja, 6º ano do ensino fundamental.
    // a matriz curricular tem todas as disciplinas de cada um das séries, sendo que grau e série estão em colunas diferentes, gra e ser, então é preciso fazer um filtro para pegar as disciplinas da série do aluno. para saber quantas disciplinas são é preciso contar quantas linhas aparecem com a combinação gra='1' e ser='6'
    //


    if ((typeof data2 !== 'undefined') && (typeof matrizCurricular !== 'undefined')) {
        chartDatSerie = data2.map((item, index) => {
            const row = [unidades[parseInt(item.unidade)]];
            row.push(ConverteSerie(item.serie));
            row.push(item.mat);
            row.push(item.nome);
            row.push(item.tur);
            let _ser = item.tur.substring(2, 3);
            console.log('SERIE=', _ser);
            let _gra = item.tur.substring(0, 1);
            console.log('GRAU=', _gra);

            let divisor = matrizCurricular.filter(item => item.ser === _ser && item.gra === _gra && item.sts === true && (parseInt(item.dis) < 340 || parseInt(item.dis) > 357)).length;
            console.log("divisor", divisor);


            let D1 = parseFloat(((parseFloat(item.c1) / (divisor * 25)) * 100).toFixed(2));
            let D2 = parseFloat(((parseFloat(item.c2) / (divisor * 25)) * 100).toFixed(2));
            let D3 = parseFloat(((parseFloat(item.c3) / (divisor * 25)) * 100).toFixed(2));
            let D4 = parseFloat(((parseFloat(item.c4) / (divisor * 25)) * 100).toFixed(2));

            let Desempenho = ((parseFloat(item.c1) + parseFloat(item.c2) + parseFloat(item.c3) + parseFloat(item.c4)) / (divisor * 100) * 100).toFixed(2);


            row.push(D1);
            row.push(D2);
            row.push(D3);
            row.push(D4);
            row.push(parseFloat(Desempenho));

            return row;
        });
    };


    //chartDatSerie.sort();
    chartDatSerie.unshift(["Unidade", "Série", "Matricula", "Nome", "Turma", "D. Ciclo 1", "D Ciclo 2", "D. Ciclo 3", "D. Ciclo 4", "D. Anual"]);

    const options = {
        allowHtml: true,
    };

    const formatters = [
        {
            type: "ColorFormat",
            column: 5,
            ranges: [
                [0, 25, "white", "black"],
                [25, 50, "white", "red"],
                [50, 70, "white", "orange"],
                [70, 90, "white", "green"],
                [90, 101, "white", "blue"],
            ],
        },
        {
            type: "NumberFormat",
            column: 5,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 6,
            ranges: [
                [0, 25, "white", "black"],
                [25, 50, "white", "red"],
                [50, 70, "white", "orange"],
                [70, 90, "white", "green"],
                [90, 101, "white", "blue"],
            ],
        },
        {
            type: "NumberFormat",
            column: 6,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 7,
            ranges: [
                [0, 25, "white", "black"],
                [25, 50, "white", "red"],
                [50, 70, "white", "orange"],
                [70, 90, "white", "green"],
                [90, 101, "white", "blue"],
            ],
        },
        {
            type: "NumberFormat",
            column: 7,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 8,
            ranges: [
                [0, 25, "white", "black"],
                [25, 50, "white", "red"],
                [50, 70, "white", "orange"],
                [70, 90, "white", "green"],
                [90, 101, "white", "blue"],
            ],
        },
        {
            type: "NumberFormat",
            column: 8,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 9,
            ranges: [
                [0, 25, "white", "black"],
                [25, 50, "white", "red"],
                [50, 70, "white", "orange"],
                [70, 90, "white", "green"],
                [90, 101, "white", "blue"],
            ],
        },
        {
            type: "NumberFormat",
            column: 9,
            options: {
                suffix: "%",
            },
        },
    ];
    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>

                </>
            );
        if (Nperfil.startsWith("DIRETOR")) {
            var numerosString = Nperfil.replace("DIRETOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });

            return (codigoDinamico)
        };
        if (Nperfil.startsWith("SUPERVISOR")) {
            var numerosString = Nperfil.replace("SUPERVISOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });

            return (codigoDinamico)
        };
    }


    return (
        <div className="Evasão">
            <div className="sticky-top painel">

                <Navbar expand="lg" className="bg-body-tertiary">

                    <Navbar.Brand href="/">
                        <img
                            src="/novo-logo.png"
                            alt="Santa Mônica Rede de Ensino"
                            style={{ width: "40px", height: "40px", marginRight: "10px" }}
                        />
                        <span style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>Santa Mônica Rede de Ensino</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">

                        <NavDropdown
                            title="UNIDADES"
                        >
                            {Experiment(perfil[0].perfil)}

                        </NavDropdown>
                        <Nav.Link href={`${process.env.REACT_APP_FRONTEND}/ranking`}>RANKING DE ALUNOS</Nav.Link>
                    </Navbar.Collapse>
                </Navbar>


            </div>
            <center>
                <h1>
                    Ranking de Desempenho dos Alunos
                </h1>

            </center>
            <br />
            <center>
                <Chart
                    chartType="Table"
                    width="100%"
                    data={chartDatSerie}
                    options={options}
                    formatters={formatters}
                    controls={[
                        {
                            controlEvents: [
                                {
                                    eventName: "statechange",
                                    callback: ({ chartWrapper, controlWrapper }) => {
                                        console.log("State changed to", controlWrapper?.getState());
                                    },
                                },
                            ],
                            controlType: "CategoryFilter",
                            options: {
                                filterColumnIndex: 0,
                                ui: {
                                    labelStacking: "vertical",
                                    label: "Unidade",
                                    allowTyping: false,
                                    allowMultiple: true,
                                },
                            },
                        },
                        {
                            controlEvents: [
                                {
                                    eventName: "statechange",
                                    callback: ({ chartWrapper, controlWrapper }) => {
                                        console.log("State changed to", controlWrapper?.getState());
                                    },
                                },
                            ],
                            controlType: "CategoryFilter",
                            options: {
                                filterColumnIndex: 1,
                                ui: {
                                    labelStacking: "vertical",
                                    label: "Série",
                                    allowTyping: false,
                                    allowMultiple: true,
                                },
                            },
                        },
                        {
                            controlEvents: [
                                {
                                    eventName: "statechange",
                                    callback: ({ chartWrapper, controlWrapper }) => {
                                        console.log("State changed to", controlWrapper?.getState());
                                    },
                                },
                            ],
                            controlType: "CategoryFilter",
                            options: {
                                filterColumnIndex: 4,
                                ui: {
                                    labelStacking: "vertical",
                                    label: "Turma",
                                    allowTyping: false,
                                    allowMultiple: true,
                                },
                            },
                        },
                    ]}
                />

            </center>
        </div>
    );
};

export default Ranking_Alunos_Serie;
